$(() => {
  function searchSubmit() {
    if ($('input[name="term"]').length > 0) {
      $('input[name="term"]').val(encodeURIComponent($('input[name="term-tmp"]').val()));
    } else {
      const inputTerm = $('<input>')
          .attr('name', 'term')
          .attr('type', 'hidden')
          .val(encodeURIComponent($('input[name="term-tmp"]').val()));
      $(this).append(inputTerm);
    }

    $('input[name="term-tmp"]').attr('disabled', 'disabled');
  }

  if ($('input[name="term-tmp"]').length === 0) {
    $('input[name="term"]').attr('name', 'term-tmp');
  }

  $('input[name="term-tmp"]').removeAttr('disabled');

  $('#search-title').submit(searchSubmit);
});
